import api from "./api"

export const getOrgReportSummaryApi = async (org = "cubiq") => {
  const { data } = await api.get(`/api/org/${org}/report/summary`)
  return data
}

export const getOrgReportRawApi = async (org = "cubiq", options) => {
  // ! get과 동작은 똑같으나 쿼리가 많기 때문에 post로 대체
  const { data } = await api.post(`/api/org/${org}/report/raw`, { ...options })
  return data
}

export const getOrgRanges = async (org = "cubiq") => {
  const { data } = await api.get(`/api/org/${org}/report/ranges`)
  return data
}

export const getOrgLeakRawApi = async (org = "cubiq", { key, start_date, end_date }) => {
  const { data } = await api.get(`/api/org/${org}/leak/raw`, {
    params: { key, start_date, end_date }
  })
  return data
}
